import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./uuid.service";
import * as i2 from "./storage.service";
import * as i3 from "./hash.service";
var ThumbmarkJS = require('@thumbmarkjs/thumbmarkjs');
var FingerprintService = /** @class */ (function () {
    function FingerprintService(uuidService, storageService, hashService) {
        this.uuidService = uuidService;
        this.storageService = storageService;
        this.hashService = hashService;
        this.DB_KEY = 'sn_fingerprint_device_uuid';
    }
    FingerprintService.prototype.getFullIdentity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fpData, deviceUuid, comps, audioHash, mathHash, webglHash, canvasHash, screenHash, timezone, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, ThumbmarkJS.getThumbmark()];
                    case 1:
                        fpData = _a.sent();
                        return [4 /*yield*/, this.storageService.read(this.DB_KEY)];
                    case 2:
                        deviceUuid = _a.sent();
                        if (!!deviceUuid) return [3 /*break*/, 4];
                        deviceUuid = this.uuidService.generateUUID();
                        return [4 /*yield*/, this.storageService.save(this.DB_KEY, deviceUuid)];
                    case 3:
                        _a.sent();
                        localStorage.setItem(this.DB_KEY, deviceUuid);
                        _a.label = 4;
                    case 4:
                        comps = fpData && fpData.components ? fpData.components : {};
                        audioHash = comps.audio ? this.hashService.getParametersHash(comps.audio) : null;
                        mathHash = comps.math ? this.hashService.getParametersHash(comps.math) : null;
                        webglHash = comps.webgl ? this.hashService.getParametersHash(comps.webgl) : null;
                        canvasHash = comps.canvas ? this.hashService.getParametersHash(comps.canvas) : null;
                        screenHash = comps.screen ? this.hashService.getParametersHash(comps.screen) : null;
                        timezone = (comps.locales && comps.locales.timezone) ? comps.locales.timezone : null;
                        return [2 /*return*/, {
                                device_uuid: deviceUuid,
                                hash: fpData ? this.hashService.getParametersHash(fpData.thumbmark) : null,
                                math: mathHash,
                                webgl: webglHash,
                                canvas: canvasHash,
                                audio: audioHash,
                                screen: screenHash,
                                timezone: timezone,
                                isStandalone: window.matchMedia('(display-mode: standalone)').matches
                            }];
                    case 5:
                        error_1 = _a.sent();
                        return [2 /*return*/, localStorage.getItem(this.DB_KEY) || this.uuidService.generateUUID()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    FingerprintService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FingerprintService_Factory() { return new FingerprintService(i0.ɵɵinject(i1.UuidService), i0.ɵɵinject(i2.StorageService), i0.ɵɵinject(i3.HashService)); }, token: FingerprintService, providedIn: "root" });
    return FingerprintService;
}());
export { FingerprintService };
